// PropertyDetails.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import DynamicTabsPage from "../tabs/tabs";
import apiHelper from '../../utils/apiHelper';
import { EntityType, PropertyService } from '@propertelligent/client-api';
import PropertyCardItem from './PropertyCardItem';
import SimpleSpinner from '../../components/loader';
import { URLS } from '../../constants/constants';

const PropertyDetails2 = () => {
  const { id } = useParams();
  const [listingData, setListingData] = useState(null);
   const [loading, setLoading] = useState(true);
  const [showConfirmation, setShowConfirmation] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [unitRefreshTrigger, setUnitRefreshTrigger] = useState(0);
  const [paymentRefreshTrigger, setPaymentRefreshTrigger] = useState(0);
  const navigate = useNavigate();

  // Function to fetch property data
  const fetchPropertyData = async () => {
    if (!id) return;
    setLoading(true);  
      try {
        const res = await apiHelper(PropertyService.getApiProperty1, { showNotification: false }, id);
        if (res?.data?.success) {
          setListingData(res.data.success);
          setShowConfirmation(null);
        }
      } catch (err) {
        console.error("Error fetching property:", err);
        setShowConfirmation(null);
      }
      finally {
        setLoading(false); 
      }
  };

  // Fetch property data on component mount
  useEffect(() => {
    fetchPropertyData();
  }, [id]);


  const handleUnitAdded = () => {
    fetchPropertyData(); // Refresh property stats (e.g. Total Units count)
    setUnitRefreshTrigger(prev => prev + 1); // Signal Unit Tab to refresh
  };

  const handlePaymentAdded = () => {
    fetchPropertyData(); // Refresh property header stats (e.g. Income Due)
    setPaymentRefreshTrigger(prev => prev + 1); // Signal PaymentList to refresh
  };


  // Handle delete property action

  const handleDeleteProperty = (propertyId) => {
    if (isDeleting) return;

    setIsDeleting(true);
    apiHelper(PropertyService.deleteApiProperty, {
      successMessage: "Property Deleted Successfully",
      showNotification: true,
    }, propertyId).then((res) => {
      if (res?.data?.success) {
        navigate(URLS.PROPERTIES);
        setShowConfirmation(false);
      }
    }).catch((err) => {
      console.error("Error deleting property:", err);
      setShowConfirmation(false);
    }).finally(() => {
      setIsDeleting(false);
    });
  };

  const tabs = [
    "Overview",
    "Units",
    "Tenants",
    "Service Requests",
    "Payments",
    "Leases",
    "Transactions",
    "Additional Details"
  ];

  if (loading) {
    return (
     <SimpleSpinner myClassName={"Icon50"} isFullPage={true} />
    );
  }

  return (
    <div className='content-wrapper property-details-container'>
      {listingData ? (
        <PropertyCardItem
          className="property-card-item-single"
          listingData={listingData}
          IsFooter={true}
          showConfirmation={showConfirmation}
          setShowConfirmation={setShowConfirmation}
          handleDeleteProperty={handleDeleteProperty}
          isDeletingProperty={isDeleting}
          onUnitAdded={()=> {
            handleUnitAdded();
            fetchPropertyData();
          }}
          onPaymentAdded={handlePaymentAdded}
          disableNavigation={true}
        />
      ) : (
        <></>
      )}
      <DynamicTabsPage
        tabs={tabs}
        defaultActiveTab="Overview"
        entityType={EntityType.Property}
        onUnitAdded={fetchPropertyData} // Pass the refresh callback
        onServiceRequestAdded={fetchPropertyData} // Pass the refresh
        unitRefreshTrigger={unitRefreshTrigger}
        paymentRefreshTrigger={paymentRefreshTrigger}
        onPaymentAction={handlePaymentAdded}
      />
    </div>
  );
};

export default PropertyDetails2;